if (!customElements.get('wlsn-tabs-strength')) {
  class WLSNTabsStrength extends HTMLElement {
    constructor() {
      super();

      /** @type {IntersectionObserver | null} */
      this._observer = null;
    }

    get elements() {
      return {
        progressBars: this.querySelectorAll('wlsn-strength-progress-bar'),
      };
    }

    connectedCallback() {
      const { progressBars } = this.elements;
      
      if (!progressBars) return;
      
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in-view');
              this._observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -100px 0px', threshold: 0 }
      );

      progressBars.forEach((bar) => {
        this._observer.observe(bar);
      });
    }

    disconnectedCallback() {
      this._observer?.disconnect();
      this._observer = null;
    }
  }

  customElements.define('wlsn-tabs-strength', WLSNTabsStrength);
}
